import { setThemeColor, ThemeShades } from '@bamboohr/fabric';

export function setupTheme() {
	function setupThemeHandler() {
		const theme = document.body.getAttribute('ba-theme');

		if (typeof theme === 'string' && theme.startsWith('{')) {
			const parsedTheme: ThemeShades = JSON.parse(theme) as ThemeShades;
			setThemeColor(parsedTheme);
		}
	}

	if (document.body) {
		setupThemeHandler();
		return;
	}

	const observer = new MutationObserver((mutations, obs) => {
		if (document.body?.hasAttribute('ba-theme')) {
			setupThemeHandler();
			obs.disconnect();
		}
	});

	observer.observe(document.documentElement, {
		childList: true,
		subtree: true,
	});
}
